'use client';

import { useRef, useEffect } from 'react';

import { useAppContext } from 'src/context/app';

import { toast } from 'src/components/snackbar';

import { useAuthContext } from 'src/auth/hooks';

import { HämtaOrganisationerFörAnvändare } from 'src/sections/organisation/OrganisationsService';
import {
  accepteraInbjudan,
  INBJUDAN_VÄNTANDE_KEY,
} from 'src/sections/organisation/InbjudanService';

/**
 * Safety net for the register flow (which does not preserve returnTo and routes new users
 * through onboarding). When an authenticated user lands in the dashboard with a pending
 * invite id in localStorage, this completes the join and clears the flag. Accept is
 * idempotent, so it's harmless if the invite was already accepted on the public page.
 */
export default function InbjudanAutoAccept() {
  const { authenticated } = useAuthContext();
  const { uppdateraValdOrganisation } = useAppContext();
  const körd = useRef(false);

  useEffect(() => {
    if (!authenticated || körd.current) return;

    let inbjudanId: string | null = null;
    try {
      inbjudanId = localStorage.getItem(INBJUDAN_VÄNTANDE_KEY);
    } catch {
      return;
    }
    if (!inbjudanId) return;

    körd.current = true;
    (async () => {
      try {
        await accepteraInbjudan(inbjudanId!);
        try {
          const orgs = await HämtaOrganisationerFörAnvändare();
          if (orgs.length > 0) uppdateraValdOrganisation(orgs[orgs.length - 1]);
        } catch {
          /* org selection is best-effort */
        }
        toast.success('Du har gått med i organisationen');
      } catch (error) {
        console.error('Kunde inte slutföra inbjudan automatiskt', error);
      } finally {
        try {
          localStorage.removeItem(INBJUDAN_VÄNTANDE_KEY);
        } catch {
          /* ignore */
        }
      }
    })();
  }, [authenticated, uppdateraValdOrganisation]);

  return null;
}
